import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import SideEditor from '../../general/SideEditor';
import BudgetGroupEditor from './BudgetGroupEditor';
import { fetchWorkers, fetchCompanyBudgetGroups, setEditedEntity, deleteBudgetGroup, confirmDelete } from '../../../actions';
import { getBudgetGroups } from '../../../selectors';
import { formatPrice } from '../../../helpers/format';

class BudgetGroups extends Component {
    componentWillMount() {
        if (this.props.company.id) {
            this.props.fetchCompanyBudgetGroups(this.props.company.id);
            this.props.fetchWorkers(this.props.company.id);
        }
    }

    handleDelete(group) {
        this.props.confirmDelete(group.name, () => this.props.deleteBudgetGroup(this.props.company.id, group.id));
    }

    render() {
        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('addBudgetGroup')}
                    visible={this.props.onEdit}
                    handleClose={() => this.props.setEditedEntity(null)}
                >
                    <BudgetGroupEditor company={this.props.company} />
                </SideEditor>
                <div style={{ marginBottom: 10 }}>
                    <Button
                        icon
                        labelPosition='left'
                        primary
                        onClick={() => this.props.setEditedEntity('budgetGroup')}
                    >
                        <Icon name='add' /> {i18next.t('addBudgetGroup')}
                    </Button>
                </div>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell singleLine>{i18next.t('name')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('monthlyLimit')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('dailyLimit')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('subsidy')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('workers')}</Table.HeaderCell>
                            <Table.HeaderCell singleLine>{i18next.t('actions')}</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {this.props.budgetGroups.map((group) => {
                            return (
                                <Table.Row key={group.id}>
                                    <Table.Cell>{group.name}</Table.Cell>
                                    <Table.Cell>
                                        {formatPrice(group.monthlyLimit, this.props.company.currencyCode)}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {formatPrice(group.dailyLimit, this.props.company.currencyCode)}
                                    </Table.Cell>
                                    <Table.Cell>{`${group.subsidyValue}%`}</Table.Cell>
                                    <Table.Cell>{group.cards || 0}</Table.Cell>
                                    <Table.Cell collapsing>
                                        <Button circular size='tiny' icon='write' basic onClick={() => this.props.setEditedEntity('budgetGroup', group)} />
                                        {group.cards ? null :
                                            <Button circular size='tiny' icon='trash' negative onClick={() => this.handleDelete(group)} />
                                        }
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

BudgetGroups.propTypes = {
    company: PropTypes.object,
    fetchWorkers: PropTypes.func,
    fetchCompanyBudgetGroups: PropTypes.func,
    onEdit: PropTypes.bool,
    budgetGroups: PropTypes.array,
    setEditedEntity: PropTypes.func,
    deleteBudgetGroup: PropTypes.func,
    confirmDelete: PropTypes.func,
    
};

const mapStateToProps = (state, ownProps) => {
    const budgetGroups = getBudgetGroups(state);
    const onEdit = state.editor.type === 'budgetGroup';

    return { budgetGroups, onEdit };
};

export default connect(mapStateToProps, {
    fetchWorkers, fetchCompanyBudgetGroups, setEditedEntity, deleteBudgetGroup, confirmDelete
})(BudgetGroups);
